<div class="flex-column gap">
    <app-card [title]="headerTitle()">
        <ng-template #content>
            <div class="flex gap">
                <app-date-input [form]="form" class="flex-1" id="from"></app-date-input>

                <app-select-input
                    id="state"
                    [form]="form"
                    class="flex-1 w-full"
                    label="person.dependence.fields.state"
                    [staticOptions]="[
                        {
                          name: 'person.dependence.states.' + PersonDependenceStateEnum.ADMITTED,
                          value: PersonDependenceStateEnum.ADMITTED
                        },
                        {
                          name: 'person.dependence.states.' + PersonDependenceStateEnum.REQUESTED,
                          value: PersonDependenceStateEnum.REQUESTED
                        },
                        {
                          name: 'person.dependence.states.' + PersonDependenceStateEnum.NOT_ADMITTED,
                          value: PersonDependenceStateEnum.NOT_ADMITTED
                        },
                        {
                          name: 'person.dependence.states.' + PersonDependenceStateEnum.NOT_REQUESTED,
                          value: PersonDependenceStateEnum.NOT_REQUESTED
                        },
                    ]"
                ></app-select-input>

                <app-select-input
                    [hidden]="form.controls.state?.value === 4"
                    id="degree"
                    [form]="form"
                    class="flex-1 w-full"
                    label="person.dependence.fields.degree"
                    [staticOptions]="[
                        { name: 'person.dependence.degrees.1', value: 1 },
                        { name: 'person.dependence.degrees.2', value: 2 },
                        { name: 'person.dependence.degrees.3', value: 3 },
                        { name: 'person.dependence.degrees.4', value: 4 },
                    ]"
                    [showClear]="true"
                ></app-select-input>
            </div>

            <div class="flex gap justify-content-end pt-4">
                @if (form.value.id) {
                    <app-cancel-button (clickEvent)="form.reset()"></app-cancel-button>
                }

                <app-save-button
                    [label]="(form.value.id ? 'common.update' : 'common.assign')" (clickEvent)="submit()"
                ></app-save-button>
            </div>
        </ng-template>
    </app-card>

    <app-card-table
        [gridData]="store.data.getPersonDependences()"
        [refreshCallback]="store.api.getPersonDependences"
        [refreshCallbackFragment]="dependenceFrag"
        [additionalFilter]="additionalFilters()"
        [columns]="columns"
        [tableTitle]="'person.dependence.assignedDependences'"
        [translatePrefix]="prefix"
        (detailCallback)="updateRecord($event)"
        (deleteCallbackWithEvent)="deleteRecord($event)"
    >
        <ng-template pTemplate="state" let-data="data">
            {{ ('person.dependence.states.' + data) | translate }}
        </ng-template>

        <ng-template pTemplate="degree" let-item="item">
            @if (item.dependence?.degree) {
                {{ ('person.dependence.degrees.' + item.dependence.degree) | translate }}
            }
        </ng-template>
    </app-card-table>
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-cancel-button label="common.close" (clickEvent)="dialogRef.close()"></app-cancel-button>
</div>
